var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('nav',{staticClass:"main-nav"},[(_vm.menu)?_c('ul',{staticClass:"main-menu main-nav__menu"},_vm._l((_vm.menu),function(menuitem,index){return _c('desktop-menu-item',{key:menuitem.order,attrs:{"item":menuitem}})}),1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }